// extracted by mini-css-extract-plugin
export default {"welcomeModal":"_2nK5NFbCU5wPdc5oAFvSCd","closeButton":"_3Oa-G5mqxm5f0NFJfGZo4Y","title":"_1Nu7MSXL7rpC1g06fdy3F3","footnote":"kizMd_w5g9DLtbg36lAsG"};